export default __webpack_public_path__ + "static/media/onrise.110e3670.svg";